const escapeHtml = (text) =>
  String(text ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

const SafeText = ({ text, className = '', prefix = '' }) => {
  if (!text) return null;
  return (
    <div className={`whitespace-pre-wrap break-words ${className}`}>
      {prefix}
      {text}
    </div>
  );
};

export const SafeInline = ({ text, className = '', prefix = '' }) => {
  if (!text) return null;
  return (
    <span className={`whitespace-pre-wrap break-words ${className}`}>
      {prefix}
      {text}
    </span>
  );
};

export const escapeText = (text) => escapeHtml(text);

export default SafeText;
